import { useCallback, useEffect, useState } from 'react'
import Multiselect from 'multiselect-react-dropdown'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy } from '@fortawesome/free-solid-svg-icons'

const AddPageSection = ({ books }) => {
  const [pageNumber, setPageNumber] = useState(-1)
  const [selectedBook, setSelectedBook] = useState([])
  const [userText, setUserText] = useState('Vezi pagina')

  useEffect(() => {
    setUserText(`Vezi pagina ${pageNumber !== -1 ? pageNumber : ''}`)
  }, [pageNumber])

  const getPageResult = useCallback(() => {
    if (
      pageNumber <= 0 ||
      isNaN(pageNumber) ||
      selectedBook.length === 0 ||
      userText.length === 0
    ) {
      return 'Adauga valori valide in input'
    }

    return `<page#${parseInt(pageNumber)}#${selectedBook[0]?.id}#${userText}>`
  }, [pageNumber, selectedBook, userText])

  return (
    <div className="rounded-xl border border-brd-primary text-over-ternary-background p-5 bg-container-background mt-4">
      <div className="mb-[10px] flex-col gap-3">
        <div className="text-base lg:text-xl capitalize self-center mr-1 flex">
          Adauga pagina
        </div>
        <div className="grid grid-cols-1 min-[600px]:grid-cols-2 min-[1600px]:grid-cols-3 gap-1 mt-2">
          <div className="flex">
            <label
              className="text-sm lg:text-base text-over-ternary-background capitalize self-center mr-1 flex mt-[4px]"
              htmlFor="pageNumber"
            >
              Numar:
            </label>
            <input
              className="border bg-container-background text-over-ternary-background border-brd-primary rounded-md text-sm p-2 ml-1 w-[80px] h-10"
              id="pageNumber"
              placeholder="Numar pagină"
              value={pageNumber}
              onChange={e => {
                setPageNumber(e.target.value)
              }}
              type="number"
            />
          </div>
          <div className="flex">
            <div className="text-sm lg:text-base text-over-ternary-background capitalize self-center mr-1">
              Carte:
            </div>
            <Multiselect
              className="border rounded border-brd-primary text-sm bg-container-background text-over-ternary-background flex w-[350px] h-10 max-w-[350px]"
              style={{
                selectContainer: {
                  backgroundColor: 'red',
                },
                optionContainer: {
                  backgroundColor: 'rgb(var(--secondary-background))',
                  color: 'rgb(var(--over-secondary-background))',
                },

                searchBox: {
                  border: 'none',
                },
                chips: {
                  backgroundColor: 'rgb(var(--ternary))',
                },
              }}
              options={books}
              selectedValues={selectedBook}
              onSelect={(selectedList, selectedItem) => {
                setSelectedBook([selectedItem])
              }}
              onRemove={() => {
                setSelectedBook([])
              }}
              showArrow={false}
              closeOnSelect={true}
              displayValue="name"
              hidePlaceholder={true}
            />
          </div>

          <div className="flex">
            <label
              className="text-sm lg:text-base text-over-ternary-background capitalize self-center flex mr-1"
              htmlFor="userText"
            >
              Text:
            </label>
            <input
              className="border bg-container-background text-over-ternary-background border-brd-primary rounded-md text-sm p-2 w-[200px] h-10"
              id="userText"
              placeholder="Text de afisat"
              value={userText}
              onChange={e => {
                setUserText(e.target.value)
              }}
              type="text"
            />
          </div>
        </div>
        <div>
          <label
            className="text-sm lg:text-base text-over-ternary-background capitalize self-center mr-1 mt-[4px]"
            htmlFor="result"
          >
            Rezultat:
          </label>
          <input
            className="border bg-container-background text-over-ternary-background border-brd-primary rounded-md text-sm p-2 mt-3 w-[400px] h-10"
            id="result"
            placeholder="Rezultat"
            value={getPageResult()}
            type="text"
            readOnly
          />
          <FontAwesomeIcon
            icon={faCopy}
            className="hover:cursor-pointer ml-2"
            onClick={() => {
              navigator.clipboard.writeText(getPageResult())
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default AddPageSection
